<template>
  <div>
    <div class="pb-4 d-flex justify-content-between align-items-center">
      <div class="d-flex flex-column">
        <small class="text-muted mb-1">
          <font-awesome-icon icon="truck" fixed-width class="mr-1" />{{$t("global.sonstiges")}}
        </small>
        <h1 class="h2">{{$t("onTheRoad.titel")}}</h1>
      </div>
      <router-link
        :to="{ name: 'BearbeiteAjaOnTheRoad' }"
        class="btn btn-primary align-self-center"
        v-show="$store.state.isAdminAja === 'true' || $store.state.isAdminAja"
      >
        <font-awesome-icon icon="cog" class="mr-2" />{{ $t("global.ansichtBearbeiten") }}
      </router-link>
    </div>
    <b-card no-body class="shadow-sm">
      <b-tabs pills card vertical>
        <b-tab no-body :title="element.name" v-for="(element, index) in onTheRoad" :key="`tab-${index}`">
          <OnTheRoadTabelle :businessUnit="element" />
        </b-tab> 
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import OnTheRoadTabelle from './OnTheRoadTabelle.vue'
import _ from 'lodash'

export default {
  name: 'OnTheRoadReiter',
  components: {
    OnTheRoadTabelle
  },
  mounted() {
    this.$store.dispatch('fetchOnTheRoad')
    .then(() => {
      const onTheRoadSortiert = _.sortBy(this.$store.state.onTheRoad, ['name'])
      this.onTheRoad = onTheRoadSortiert
    })
  },
  data() {
    return {
      onTheRoad: []
    }
  }
}
</script>
